import { Component, Host, h, Prop } from "@stencil/core";
import {
    getDiscontinuationStatusIcon,
    getDiscontinuationStatusColor,
} from "../../utils/discontinuationStatus";

@Component({
    tag: "ux-iws-discontinuation-icon",
    styleUrl: "discontinuation-icon.scss",
    shadow: false,
})
export class DiscontinuationIcon {
    /** discontinuation info */
    @Prop({ reflect: true }) status: string;
    /** string info */
    @Prop({ reflect: true }) type: string;
    /** string info */
    @Prop({ reflect: true }) extendedSupport: boolean;
    /** unique string that identifies the tooltip */
    @Prop() tooltipIdentifier: string;

    render() {
        const { type, status, extendedSupport, tooltipIdentifier } = this;

        return (
            <Host
                class="ux-iws-discontinuation-icon"
                style={{ color: `${getDiscontinuationStatusColor(status)}` }}
            >
                <ux-icon
                    class="ux-iws-discontinuation-icon__icon"
                    name={getDiscontinuationStatusIcon(
                        status,
                        type,
                        extendedSupport
                    )}
                    size-l="27"
                    data-tooltip-id={`ux-iws-${tooltipIdentifier}`}
                />
                <div class="ux-iws-discontinuation-icon__slot">
                    <slot />
                </div>
            </Host>
        );
    }
}
